import { PatternFormat } from 'react-number-format';

const TextFieldCellPhone = ({ celular, handleChange }) => {
    return (

        <>
            <PatternFormat
                format="(##) #####-####"
                allowEmptyFormatting
                mask="_"
                placeholder='(XX) XXXXX-XXXX'
                onChange={handleChange}
                value={celular ? celular : ''}
                name="celular"
            />
            {/* <ReactInputMask
                mask="(99) 99999-9999"
                name="celular"
                onChange={handleChange}
                value={celular ? celular : ''}
                maskchar="_"
            >
                <TextField
                    variant="outlined"
                    margin="normal"
                    size='small'
                    fullWidth
                    label="Celular"
                />
            </ReactInputMask> */}

        </>
    );
}

export default TextFieldCellPhone;